function calculateRowItem(row_old, pigv) {
    let unit_price = row_old.unit_price_init
    let warehouse_id = row_old.warehouse_id;
    let record_id = (row_old.record_id) ? row_old.record_id : (row_old.id ? row_old.id : null)
    let has_isc = row_old.has_isc;
    let percentage_igv = pigv * 100

    let row = {
        index: row_old.index,
        id: row_old.id,
        item_id: row_old.item_id ? row_old.item_id : row_old.item.id,
        name: row_old.name,
        item: row_old.item,
        unit_type_id: row_old.unit_type_id,
        currency_type_id: row_old.currency_type_id,
        quantity: parseFloat(row_old.quantity),
        quantity_init: parseFloat(row_old.quantity_init),
        unit_value_init: 0,
        unit_value: 0,
        unit_price_init: parseFloat(unit_price),
        unit_price: parseFloat(unit_price),
        affectation_igv_type_id_init: row_old.affectation_igv_type_id,
        affectation_igv_type_id: row_old.affectation_igv_type_id,
        affectation_igv_type: row_old.affectation_igv_type,
        total_base_igv: 0,
        percentage_igv: percentage_igv,
        total_igv: 0,
        system_isc_type_id: has_isc ? row_old.system_isc_type_id : null,
        total_base_isc: 0,
        percentage_isc: has_isc ? parseFloat(row_old.percentage_isc) : 0,
        total_isc: 0,
        total_base_other_taxes: 0,
        percentage_other_taxes: 0,
        total_other_taxes: 0,
        total_plastic_bag_taxes: 0,
        total_taxes: 0,
        price_type_id: '01',
        input_unit_price_value: row_old.input_unit_price_value,
        total_value: 0,
        total_discount: 0,
        total_charge: 0,
        total: 0,
        attributes: row_old.attributes,
        charges: row_old.charges,
        discounts: row_old.discounts,
        warehouse_id: warehouse_id,
        name_product_pdf: row_old.name_product_pdf,
        record_id: record_id, // fixed for update sale_note

        //valores sin redondeo, se usa en los calculos (invoice) para mayor precision
        total_value_without_rounding: 0,
        total_base_igv_without_rounding: 0,
        total_igv_without_rounding: 0,
        total_taxes_without_rounding: 0,
        total_without_rounding: 0,
        is_set: row_old.is_set,
        calculate_quantity: row_old.calculate_quantity,
        exchange_points: row_old.exchange_points,
        quantity_of_points: row_old.quantity_of_points,
        used_points_for_exchange: row_old.used_points_for_exchange,

        //
        // purchase_unit_price: row_old.item.purchase_unit_price,
        // purchase_unit_value: row_old.item.purchase_unit_value,
        // purchase_has_igv: row_old.item.has_igv,
        // lots: row_old.lots,
        // IdLoteSelected: row_old.IdLoteSelected,

        data_item_lot_group: getDataItemLotGroup(row_old),
        activate_discount_on_discount: row_old.hasOwnProperty('activate_discount_on_discount') ? row_old.activate_discount_on_discount : false
    }

    let unit_value = row.unit_price
    if (row.affectation_igv_type_id === '10') {
        unit_value = (row.unit_price / (1 + percentage_igv / 100)).toFixed(8)
    }
    row.unit_value_init = unit_value
    row.unit_value = unit_value

    let total_price_partial = parseFloat((unit_price * row.quantity).toFixed(2))
    let total_value_partial = parseFloat((unit_value * row.quantity).toFixed(2)) //parseFloat((total_price_partial / 1.18).toFixed(2))

    /* Discounts */
    let discount_base = 0
    let discount_no_base = 0

    if (row.discounts && row.discounts.length > 0) {
        let aux_base = total_value_partial;
        let aux_price = total_price_partial;
        row.discounts.forEach((discount, index) => {
            if (parseFloat(discount.percentage) > 0 || parseFloat(discount.amount_base) > 0) {
                console.log('con descuento')
                let affectation_igv_type_exonerated = ['20', '21', '30', '31', '32', '33', '34', '35', '36', '37']
                if (discount.is_amount) {
                    if (discount.discount_type.base) {
                        discount.percentage = parseFloat(discount.amount_base) / total_price_partial * 100
                        discount.factor = _.round(discount.percentage / 100, 5)
                        discount.base = _.round(aux_base, 2);
                        discount.amount = _.round(discount.base * discount.factor, 2) //_.round(discount.base * discount.factor, 2)
                        discount_base += parseFloat(discount.amount_base)
                        if (row.activate_discount_on_discount) {
                            aux_base = discount.base - discount.amount
                        }
                    } else {
                        let aux_total_line = row.unit_price * row.quantity
                        discount.base = _.round(aux_total_line, 2)
                        discount.amount = getAmountFromInputDiscount(discount)
                        discount.percentage = _.round(100 * (parseFloat(discount.amount) / parseFloat(discount.base)), 2)
                        discount.factor = _.round(discount.percentage / 100, 5)
                    }
                } else {
                    if (discount.discount_type.base) {
                        discount.percentage = parseFloat(discount.percentage)
                        discount.factor = _.round(discount.percentage / 100, 5)
                        discount.base = _.round(aux_base, 2)
                        discount.amount = _.round(discount.base * discount.factor, 2)
                        discount.amount_base = _.round(parseFloat(aux_price * discount.factor), 2)
                        discount_base += discount.amount_base
                        if (row.activate_discount_on_discount) {
                            aux_price -= discount.amount_base
                            aux_base -= discount.amount
                        }

                    } else {
                        let aux_total_line = row.unit_price * row.quantity
                        discount.factor = _.round(discount.percentage / 100, 5)
                        discount.amount = _.round(aux_total_line * discount.factor, 2)
                        discount.base = _.round(aux_total_line, 2)
                    }
                }
                row.discounts.splice(index, discount)
            }
        })
    }

    /* Charges */
    // let charge_base = 0
    // let charge_no_base = 0
    // if (row.charges &&  row.charges.length > 0) {
    //     row.charges.forEach((charge, index) => {
    //         charge.percentage = parseFloat(charge.percentage)
    //         charge.factor = charge.percentage / 100
    //         charge.base = _.round(total_value_partial, 2)
    //         charge.amount = _.round(charge.base * charge.factor, 2)
    //         if (charge.charge_type.base) {
    //             charge_base += charge.amount
    //         } else {
    //             charge_no_base += charge.amount
    //         }
    //         row.charges.splice(index, charge)
    //     })
    // }

    let total_charge = 0
    let total_isc = 0
    let total_other_taxes = 0
    let total_igv = total_price_partial - total_value_partial
    let total_discount = discount_base + discount_no_base
    let total_partial = total_price_partial - total_discount

    if (total_discount > 0) {
        row.unit_price = parseFloat((total_partial / row.quantity).toFixed(6))
        // row.unit_value = row.unit_price
        // if (row.affectation_igv_type_id === '10') {
        //     row.unit_value = (row.unit_price / (1 + percentage_igv / 100)).toFixed(6)
            // total_price_partial = parseFloat((unit_price * row.quantity).toFixed(2))
            // total_value_partial = parseFloat((unit_value * row.quantity).toFixed(2))
            // total_igv = total_price_partial - total_value_partial
        // }
        if (row.affectation_igv_type_id === '10') {
            total_igv = total_partial / (1 + percentage_igv / 100) * (percentage_igv / 100)
        }
        if (row.affectation_igv_type_id === '20') { //Exonerated
            total_igv = 0
        }
        if (row.affectation_igv_type_id === '30') { //Unaffected
            total_igv = 0
        }
        total_value_partial = total_partial - total_igv
    }

    // if (row.affectation_igv_type_id === '10') {
    //     total_igv = total_partial / (1 + percentage_igv / 100) * (percentage_igv / 100)
    // }
    // if (row.affectation_igv_type_id === '20') { //Exonerated
    //     total_igv = 0
    // }
    // if (row.affectation_igv_type_id === '30') { //Unaffected
    //     total_igv = 0
    // }

    // let total_value = total_partial - total_igv
    row.unit_value = parseFloat((total_value_partial / row.quantity).toFixed(6))

    let total_base_igv = total_value_partial
    let total_plastic_bag_taxes = 0

    if (row_old.has_plastic_bag_taxes) {
        total_plastic_bag_taxes = _.round(row.quantity * row.item.amount_plastic_bag_taxes, 1)
        row.total_plastic_bag_taxes = total_plastic_bag_taxes
    }

    let total_taxes = total_igv + total_isc + total_other_taxes + total_plastic_bag_taxes
    let total = total_value_partial + total_taxes

    row.total_charge = _.round(total_charge, 2)
    row.total_discount = _.round(total_discount, 2)
    row.total_charge = _.round(total_charge, 2)
    row.total_value = _.round(total_value_partial, 2)
    row.total_base_igv = _.round(total_base_igv, 2)
    row.total_igv = _.round(total_igv, 2)
    row.total_taxes = _.round(total_taxes, 2)
    row.total = _.round(total, 2)

    //procedimiento para agregar isc
    // if (has_isc) {
    //     row.total_base_isc = _.round(total_value, 2) //total valor antes de aplicar isc
    //     row.total_isc = _.round(total_value * (row.percentage_isc / 100), 2)
    //     //calcular nueva base incrementando el valor actual + isc
    //     total_base_igv += row.total_isc
    //     row.total_base_igv = _.round(total_base_igv, 2)
    //
    //     total_igv = total_base_igv * (percentage_igv / 100)
    //     row.total_igv = _.round(total_igv, 2)
    //
    //     //asignar nuevo total impuestos, si tiene descuentos se usa total_taxes para calcular el precio unitario
    //     total_taxes = total_igv + row.total_isc + total_plastic_bag_taxes
    //     // total_taxes = total_igv + row.total_isc
    //     row.total_taxes = _.round(total_taxes, 2)
    //
    //     total = total_value + total_taxes
    //     row.total = _.round(total, 2)
    //     //calcular nuevo precio unitario
    //     row.unit_price = _.round(total / row.quantity, 6)
    // }

    // descuentos, se modifica precio unitario y total descuentos
    // if (row.discounts.length > 0) {
    //     let sum_discount_no_base = 0
    //     let sum_discount_base = 0
    //     row.discounts.forEach(discount => {
    //         sum_discount_no_base += (discount.discount_type_id === '01') ? discount.amount : 0
    //         sum_discount_base += (discount.discount_type_id === '00') ? discount.amount : 0
    //     })
    //
    //     row.unit_price = (total_value + total_taxes - sum_discount_no_base) / row.quantity
    //     let total_discounts = sum_discount_no_base + sum_discount_base;
    //     row.total_discount = _.round(total_discounts, 2)
    // }


    //valores sin redondeo, se usa en los calculos para mayor precision (método calculateTotal - Invoice)
    // row.total_value_without_rounding = total_value
    // row.total_base_igv_without_rounding = total_base_igv
    // row.total_igv_without_rounding = total_igv
    // row.total_taxes_without_rounding = total_taxes
    // row.total_without_rounding = total

    if (['10', '20', '30', '40'].indexOf(row.affectation_igv_type_id) < 0) {
        row.price_type_id = '02'
        row.unit_value = 0
        row.total = total_plastic_bag_taxes
        // row.total_without_rounding = 0
    }

    return row
}

function fCalculateTotal(form) {
    console.log('fCalculateTotal')
    let total_discount = 0
    let total_charge = 0
    let total_exportation = 0
    let total_taxed = 0
    let total_exonerated = 0
    let total_unaffected = 0
    let total_free = 0
    let total_igv = 0
    let total_value = 0
    let total = 0
    let total_plastic_bag_taxes = 0
    let total_discount_no_base = 0

    let total_igv_free = 0
    let total_base_isc = 0
    let total_isc = 0

    // let total_free_igv = 0

    form.items.forEach((row) => {
        total_discount += parseFloat(row.total_discount)
        total_charge += parseFloat(row.total_charge)

        if (row.affectation_igv_type_id === '10') {
            // total_taxed += parseFloat(row.total_value)
            if (row.total_value_without_rounding) {
                total_taxed += parseFloat(row.total_value_without_rounding)
            } else {
                total_taxed += parseFloat(row.total_value)
            }
        }

        if (row.affectation_igv_type_id === '20'  // 20,Exonerado - Operación Onerosa
            // || row.affectation_igv_type_id === '21' // 21,Exonerado – Transferencia Gratuita
        ) {
            total_exonerated += (row.total_value_without_rounding) ? parseFloat(row.total_value_without_rounding) : parseFloat(row.total_value)
        }

        if (row.affectation_igv_type_id === '30'  // 30,Inafecto - Operación Onerosa
            // || row.affectation_igv_type_id === '31'  // 31,Inafecto – Retiro por Bonificación
            || row.affectation_igv_type_id === '32'  // 32,Inafecto – Retiro
            || row.affectation_igv_type_id === '33'  // 33,Inafecto – Retiro por Muestras Médicas
            || row.affectation_igv_type_id === '34'  // 34,Inafecto - Retiro por Convenio Colectivo
            || row.affectation_igv_type_id === '35'  // 35,Inafecto – Retiro por premio
            || row.affectation_igv_type_id === '36' // 36,Inafecto - Retiro por publicidad
            // || row.affectation_igv_type_id === '37'  // 37,Inafecto - Transferencia gratuita
        ) {
            total_unaffected += parseFloat(row.total_value)
        }

        if (row.affectation_igv_type_id === '40') {
            total_exportation += parseFloat(row.total_value)
        }

        if (['10',
            // '20', '21',
            '20',
            '30', /*'31',*/  '32', '33', '34', '35', '36',
            '40'].indexOf(row.affectation_igv_type_id) < 0) {
            total_free += parseFloat(row.total_value)
        }

        if (['10',
            '20', '21',
            '30', '31', '32', '33', '34', '35', '36',
            '40'].indexOf(row.affectation_igv_type_id) > -1) {
            // total_igv += parseFloat(row.total_igv)
            // total += parseFloat(row.total)
            if (row.total_igv_without_rounding) {
                total_igv += parseFloat(row.total_igv_without_rounding)
            } else {
                total_igv += parseFloat(row.total_igv)
            }

            if (row.total_without_rounding) {
                total += parseFloat(row.total_without_rounding)
            } else {
                total += parseFloat(row.total)
            }
        }

        if (!['21', '37', '31'].includes(row.affectation_igv_type_id)) {
            // total_value += parseFloat(row.total_value)
            if (row.total_value_without_rounding) {
                total_value += parseFloat(row.total_value_without_rounding)
            } else {
                total_value += parseFloat(row.total_value)
            }
        }

        total_plastic_bag_taxes += parseFloat(row.total_plastic_bag_taxes)

        if (['11', '12', '13', '14', '15', '16'].includes(row.affectation_igv_type_id)) {
            let unit_value = row.total_value / row.quantity
            let total_value_partial = unit_value * row.quantity
            // row.total_taxes = row.total_value - total_value_partial
            row.total_taxes = row.total_value - total_value_partial + parseFloat(row.total_plastic_bag_taxes) //sumar icbper al total tributos
            row.total_igv = total_value_partial * (row.percentage_igv / 100)
            row.total_base_igv = total_value_partial
            total_value -= row.total_value
            total_igv_free += row.total_igv
            total += parseFloat(row.total) //se agrega suma al total para considerar el icbper
        }

        //sum discount no base
        total_discount_no_base += sumDiscountsNoBaseByItem(row)

        // isc
        total_isc += parseFloat(row.total_isc)
        total_base_isc += parseFloat(row.total_base_isc)
    })

    return {
        total_base_isc_init: _.round(total_base_isc, 2),
        total_isc_init: _.round(total_isc, 2),
        total_igv_free_init: _.round(total_igv_free, 2),
        total_exportation_init: _.round(total_exportation, 2),
        total_taxed_init: _.round(total_taxed, 2),
        total_exonerated_init: _.round(total_exonerated, 2),
        total_unaffected_init: _.round(total_unaffected, 2),
        total_free_init: _.round(total_free, 2),
        total_igv_init: _.round(total_igv, 2),
        total_value_init: _.round(total_value, 2),
        total_taxes_init: _.round(total_igv + total_isc + total_plastic_bag_taxes, 2),
        total_plastic_bag_taxes_init: _.round(total_plastic_bag_taxes, 2),
        total_init: total,

        total_base_isc: _.round(total_base_isc, 2),
        total_isc: _.round(total_isc, 2),
        total_igv_free: _.round(total_igv_free, 2),
        total_exportation: _.round(total_exportation, 2),
        total_taxed: _.round(total_taxed, 2),
        total_exonerated: _.round(total_exonerated, 2),
        total_unaffected: _.round(total_unaffected, 2),
        total_free: _.round(total_free, 2),
        total_igv: _.round(total_igv, 2),
        total_value: _.round(total_value, 2),
        total_taxes: _.round(total_igv + total_isc + total_plastic_bag_taxes, 2),
        total_plastic_bag_taxes: _.round(total_plastic_bag_taxes, 2),
        total: total
    }
    // this.calculateDiscountGlobal()
}

function sumDiscountsNoBaseByItem(row) {
    console.log('sumDiscountsNoBaseByItem')
    let sum_discount_no_base = 0
    if (row.discounts) {
        sum_discount_no_base = _.sumBy(row.discounts, function (discount) {
            return (discount.discount_type_id === '01') ? discount.amount : 0
        })
    }
    return sum_discount_no_base
}

function fCalculateDiscountGlobal(form, _enabled_discount_global, _discount_global_type, _discount_global_amount) {
    console.log('calculateDiscountGlobal')
    form.discounts = []
    form.total_discount = 0

    let total_exportation_init = parseFloat(form.total_exportation_init)
    let total_exonerated_init = parseFloat(form.total_exonerated_init)
    let total_unaffected_init = parseFloat(form.total_unaffected_init)
    let total_taxed_init = parseFloat(form.total_taxed_init)
    let total_init = parseFloat(form.total_init)

    let total_exportation = parseFloat(form.total_exportation)
    let total_exonerated = parseFloat(form.total_exonerated)
    let total_unaffected = parseFloat(form.total_unaffected)
    let total_taxed = parseFloat(form.total_taxed)
    let total_igv = parseFloat(form.total_igv)
    let total_plastic_bag_taxes = parseFloat(form.total_plastic_bag_taxes)
    let total = parseFloat(form.total)

    let discount_global_amount = parseFloat(_discount_global_amount)
    let discount_global_amount_base = 0
    let total_discount_base = 0
    let total_discount_no_base = 0


    total_init -= total_plastic_bag_taxes
    total = total_init

    if (_enabled_discount_global && discount_global_amount > 0) {
        let discount_global_type = _discount_global_type
        let is_amount = (discount_global_type !== '02')
        let percentage = 0
        let factor = 0
        let base = 0
        let amount = 0
        let total_partial = 0

        if (is_amount) {
            percentage = discount_global_amount / total_init * 100
            factor = _.round(percentage / 100, 5)
            discount_global_amount_base = discount_global_amount
        } else {
            percentage = discount_global_amount
            factor = _.round(percentage / 100, 5)
            discount_global_amount_base = total_init * factor
        }

        total = _.round(total_init - discount_global_amount_base, 2)
        total_partial = total

        base = total_exportation_init
        if (base > 0) {
            amount = _.round(base * factor, 2)
            total_exportation = _.round(base - amount, 2)
            total_partial -= total_exportation
            form.discounts.push({
                discount_type_id: '03',
                description: 'Descuentos globales que no afectan la base imponible del IGV/IVAP',
                factor: factor,
                amount: amount,
                base: base,
                percentage: percentage,
                is_amount: is_amount,
                type: discount_global_type,
                amount_base: discount_global_amount
            })
            total_discount_no_base += amount
        }

        base = total_exonerated_init
        if (base > 0) {
            amount = _.round(base * factor, 2)
            total_exonerated = _.round(base - amount, 2)
            total_partial -= total_exonerated
            form.discounts.push({
                discount_type_id: '03',
                description: 'Descuentos globales que no afectan la base imponible del IGV/IVAP',
                factor: factor,
                amount: amount,
                base: base,
                percentage: percentage,
                is_amount: is_amount,
                type: discount_global_type,
                amount_base: discount_global_amount
            })
            total_discount_no_base += amount
        }

        base = total_unaffected_init
        if (base > 0) {
            amount = _.round(base * factor, 2)
            total_unaffected = _.round(base - amount, 2)
            total_partial -= total_unaffected
            form.discounts.push({
                discount_type_id: '03',
                description: 'Descuentos globales que no afectan la base imponible del IGV/IVAP',
                factor: factor,
                amount: amount,
                base: base,
                percentage: percentage,
                is_amount: is_amount,
                type: discount_global_type,
                amount_base: discount_global_amount
            })
            total_discount_no_base += amount
        }

        base = total_taxed_init
        if (base > 0) {
            amount = _.round(base * factor, 2)
            total_taxed = _.round(base - amount, 2)
            total_igv = _.round(total_partial - total_taxed, 2)
            form.discounts.push({
                discount_type_id: '02',
                description: 'Descuentos globales que afectan la base imponible del IGV/IVAP',
                factor: factor,
                amount: amount,
                base: base,
                percentage: percentage,
                is_amount: is_amount,
                type: discount_global_type,
                amount_base: discount_global_amount
            })
            total_discount_base = amount
        }
    }

    form.total_discount_no_base = total_discount_no_base
    form.total_discount_base = total_discount_base
    form.total_discount = discount_global_amount_base
    form.total_exportation = total_exportation.toFixed(2)
    form.total_unaffected = total_unaffected.toFixed(2)
    form.total_exonerated = total_exonerated.toFixed(2)
    form.total_taxed = total_taxed.toFixed(2)
    form.subtotal = _.round(total_unaffected + total_exonerated + total_taxed + total_exportation, 2).toFixed(2)
    form.total_igv = total_igv.toFixed(2)
    form.total_plastic_bag_taxes = total_plastic_bag_taxes.toFixed(2)
    form.total_taxes = _.round(total_igv + total_plastic_bag_taxes, 2).toFixed(2)
    form.total = (total + total_plastic_bag_taxes).toFixed(2)

    return form

    // this.calculateDetraction()
    // this.calculateRetention()
    // this.setTotalPointsBySale(this.config)
    // this.getTotal()
}

/*
* Monto de descuento por linea
* Retorna el valor dependiendo del input asignado para monto de descuento (use_input_amount)
* use_input_amount propiedad para determinar si se toma el valor de discount.amount
* y no de discount.percentage cuando es descuento por monto
*/
function getAmountFromInputDiscount(discount) {
    let value = 0

    if (discount.use_input_amount !== undefined && discount.use_input_amount === true) {
        value = discount.amount
    } else {
        //flujo antiguo con propiedad no regularizada (algunos componentes item.vue lo usan)
        value = discount.percentage
    }

    return value
}


function getUniqueArray(arr, keyProps) {
    if (arr == null) return null
    return Object.values(
        arr.reduce((uniqueMap, entry) => {
            const key = keyProps.map((k) => entry[k]).join('|')
            if (!(key in uniqueMap)) uniqueMap[key] = entry
            return uniqueMap
        }, {})
    )
}

function showNamePdfOfDescription(item, show_pdf_name) {
    if (show_pdf_name !== undefined &&
        show_pdf_name === true &&
        item !== undefined &&
        item.name_product_pdf !== undefined &&
        item.name_product_pdf !== null
    ) {
        let temn = item.name_product_pdf;
        temn = temn.substring(3)
        temn = temn.slice(0, -4)
        if (temn.length > 0) {
            return temn;
        }
    }
    return item.description
}

function showNamePdfOfDescription2(row, show_pdf_name) {
    if (row.name !== null && row.name !== '') {
        return row.name
    }

    let item = row.item
    if (show_pdf_name !== undefined &&
        show_pdf_name === true &&
        item !== undefined &&
        item.name_product_pdf !== undefined &&
        item.name_product_pdf !== null
    ) {
        let temn = item.name_product_pdf;
        temn = temn.substring(3)
        temn = temn.slice(0, -4)
        if (temn.length > 0) {
            return temn;
        }
    }
    return item.description
}

function sumAmountDiscountsNoBaseByItem(row) {

    let sum_discount_no_base = 0

    if (row.discounts) {
        // if(row.discounts.length > 0){
        sum_discount_no_base = _.sumBy(row.discounts, function (discount) {
            return (discount.discount_type_id == '01') ? discount.amount : 0
        })
        // }
    }

    return sum_discount_no_base
}

function FormatUnitPriceRow(unit_price) {
    return _.round(unit_price, 6)
    // return unit_price.toFixed(6)
}


const filterWords = (input, items) => {
    let search_value = input.toLowerCase();
    return items.filter((item) => {
        let text_filter = item.text_filter.toLowerCase();
        return !search_value.split(' ')
            .some(p => !text_filter.includes(p));
    });
}


/**
 *
 * Retorna datos del lote en la edicion de compra
 *
 */
function getDataItemLotGroup(row_old) {
    let data = null

    if (row_old.date_of_due && row_old.lot_code) {
        data = {
            date_of_due: row_old.date_of_due,
            lot_code: row_old.lot_code,
            item_lot_group_id: row_old.item_lot_group_id,
        }
    }

    return data
}


export {
    calculateRowItem, getUniqueArray, showNamePdfOfDescription, showNamePdfOfDescription2,
    sumAmountDiscountsNoBaseByItem, FormatUnitPriceRow, filterWords, fCalculateTotal, fCalculateDiscountGlobal
}
